<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
              this.$t('report.company_dashboard.reports')
            }}
            </span>
          </li>
          <li>{{ $t('general.end_of_training_detailed_evaluation_report') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span>{{ $t('general.end_of_training_detailed_evaluation_report') }}</span>
        </h2>
      </div>
    </div>
    <!--Modal Profie-->

    <div v-if="error" class="uk-alert-danger mb-3" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color: red">
        <i class="uil-exclamation-triangle"></i> {{ error }}
      </p>
    </div>

    <!--End Modal Profile -->
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <!-- <h4 class="d-inline-block mb-0"></h4> -->
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                class="uk-search-input shadow-0 uk-form-small" type="search" />
            </div>
          </div>

          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover btn-circle"
              href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'created_at')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'created_at')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>

            <!-- Filter -->
            <filter-dropdown-button @reset="resetFilter" @filter="filterResult">
              <div class="uk-child-width-1-2@s uk-grid-small" uk-grid>
                <app-multiselect v-model="assignment_id" :allow-empty="true" :is-multiple="true" :options="assignmentList"
                  label="name" :placeholder="$t('general.select_education')" :title="$t('general.education')"
                  @input="handleAssignmentInput" />

                <app-multiselect v-model="user_id" :allow-empty="true" :is-multiple="true"
                  :options="assignmentLoading ? [] : userList"
                  :placeholder="assignmentLoading ? $t('general.loading') + '...' : $t('general.select_user')"
                  label="name" :title="$t('general.user')" />
              </div>
            </filter-dropdown-button>

            <div class="uk-inline">
              <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')" />

              <div class="uk-dropdown" uk-dropdown="mode: click; pos: bottom-right; animation: uk-animation-scale-up">
                <ul class="uk-nav uk-dropdown-nav">
                  <li>
                    <a href="javascript:;" @click="exportUserAssignment(null)">
                      {{ $t('general.regular_report') }}
                    </a>
                  </li>
                  <li>
                    <a href="javascript:;" @click="exportUserAssignment('average')">
                      {{ $t('general.cumulative_report') }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="tableLoading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t('general.assignment_name') }}</th>
                <th scope="col">{{ $t('general.first_name_and_last_name') }}</th>
                <th scope="col">{{ $t('general.email') }}</th>
                <th scope="col">{{ $t('general.register_number') }}</th>
                <th scope="col">{{ $t('excel.heading.phone') }}</th>
                <th scope="col">{{ $t('general.evaluation_question') }}</th>
                <th scope="col">{{ $t('general.evaluation_answer') }}</th>
                <th scope="col">{{ $t('general.average_point') }}</th>
                <th scope="col">{{ $t('excel.heading.response_date') }}</th>

              </tr>
            </thead>

            <tbody class="list">
              <template v-for="item in formattedItems">
                <tr>
                  <td>{{ item.assignment_name }}</td>
                  <td> {{ item.user_name }}</td>
                  <td>{{ item.user_email }}</td>
                  <td>{{ item.user_registration_number }}</td>
                  <td>{{ item.user_phone }}</td>
                  <td>
                    <p v-for="question in item.survey_questions">
                      {{ question.question }} </p>
                  </td>
                   <td>
                    <p v-for="question in item.survey_questions">
                      {{ question.answer }} </p>
                  </td>
                  
                  <td>{{ item.survey_average }}</td>
                  <td>{{ item.survey_answer_date }}</td>

                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>

    </div>
  </div>
</template>

<script>
import reports, {
  ERROR,
  GET_ITEMS,
  ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment";
import axios from "axios";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import FilterDropdownButton from "@/view/components/filter/FilterDropdownButton.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "EducationEndDetailEvaluationReport",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: {
    ExcelDownloadButton,
    Pagination,
    DefaultLoading,
    AppMultiselect,
    FilterDropdownButton
  },
  data() {
    return {
      pagination: null,
      user_id: null,
      assignment_id: [],
      error: null,
      page: 1,
      per_page: 10,
      sort: "id",
      order: "desc",
      formattedItems: [],
      userList: [],
      assignmentList: [],
      assignmentLoading: false,
      tableLoading: false,
      isReportDownloading: false,
      lastFilter: null,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
    };
  },
  computed: {
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    checkInitialState() {
      if (this.assignment_id.length === 0) {
        this.error = this.$t("validation.please_select_assignment");
      }
    },
    userStatus(statusId) {
      switch (statusId) {
        case 0:
          return this.$t("general.passive");
        case 1:
          return this.$t("general.active");
      }
    },
    getUsers(assignment_id) {
      this.assignmentLoading = true;
      let assignment_ids = [];

      assignment_id.forEach(function (r) {
        assignment_ids.push(r.id)
      })

      const isAllUserSelected = assignment_ids.some(id => id === 'all')

      let filters = {
        per_page: 0,
        sort: "id",
        order: "desc",
        fields: "id,name,surname",
        assignment_id: isAllUserSelected ? null : assignment_ids.toString(),
      };

      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/user",
          filters: filters,
        })
        .then((response) => {
          this.assignmentLoading = false;
          if (response.status) {

            let results = [
              {
                id: "all",
                name: this.$t("general.all"),
              },
            ];

            let items = response.data;

            items.forEach((item) => {
              results.push({
                id: item.id,
                name: item.name + " " + item.surname,
              });
            });
            this.userList = results;
          }
        }).catch(() => {
          this.assignmentLoading = false;
        });
    },
    exportUserAssignment(reportType = null) {
      if (this.isReportDownloading) {
        return;
      }

      let self = this;

      if (+self.assignment_id.length === 0) {
        this.error = this.$t("validation.please_select_assignment");
        return false;
      }

      this.isReportDownloading = true;

      let ids = [];
      self.assignment_id.forEach((items) => {
        ids.push(items.id);
      });
      let user_ids = [];

      // UIkit.dropdown("#filterDropdown").hide();

      if (self.user_id !== null && self.user_id.length > 0) {
        self.user_id.forEach((item) => {
          user_ids.push(item.id);
        });
      }
      axios
        .get(
          process.env.VUE_APP_BACKEND_APP_URL +
          "/api/report/export/user-assignments-detail",
          {
            params: {
              sort: self.sort,
              order: self.order,
              user_ids: user_ids.includes('all') ? [] : JSON.stringify(user_ids),
              assignment_ids: ids.includes('all') ? [] :JSON.stringify(ids),
              ...(reportType && { report_type: reportType }),
              report: Math.random() * 9999999
            },
            responseType: "blob",
            headers: this.apiHeaders,
          }
        )
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          let day = moment().format("YYYYMMDDHHMMSS");
          let suffix = reportType === "average" ? "_cumulative" : ""; 
          let fileName = "user_assignment_report_list_" + day + suffix + ".xlsx";
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
          this.isReportDownloading = false;
        })
        .catch(error => {
          console.error("API error:", error);
          this.error = this.$t("general.download_failed");
          this.isReportDownloading = false;
        })
    },
    filterResult(filter = null) {
      let self = this;
      this.error = null;
      this.tableLoading = true;

      if (+self.assignment_id.length === 0) {
        this.error = this.$t("validation.please_select_assignment");
        this.tableLoading = false;

         this.formattedItems = [];
         this.pagination = null;
        return false;
      }

      let ids = [];

      // UIkit.dropdown("#filterDropdown").hide();
      self.assignment_id.forEach((items) => {
        ids.push(items.id);
      });


      let user_ids = [];

      // UIkit.dropdown("#filterDropdown").hide();

      if (self.user_id !== null && self.user_id.length > 0) {
        self.user_id.forEach((item) => {
          user_ids.push(item.id);
        });
      }


      let filters = {
        like: self.filter.search,
        assignment_id: JSON.stringify(ids),
        user_id: JSON.stringify(user_ids),
        page: self.page,
        per_page: self.per_page,
        order: self.order,
        sort: self.sort,
      };

      this.lastFilter = {
        assignment_ids: ids.slice(),
        user_ids: user_ids.slice(),
        sort: self.sort,
        order: self.order,
        search: self.filter.search,
      };

      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/user-assignments-detail",
          filters: filters,
        })
        .then((response) => {
          this.tableLoading = false;
          if (response.status) {
            let results = [];
            let responseData = response.data;
            this.pagination = responseData;

            responseData.data.forEach((item) => {

              results.push({
                'user_name': item.user_name,
                'user_email': item.user_email,
                'user_phone': item.user_phone,
                'user_registration_number': item.user_registration_number,
                'survey_questions': item.survey_questions,
                'survey_answer_date': item.survey_answer_date,
                'assignment_name': item.assignment_name,
                'survey_average': item.survey_average,
              });
            });

            this.formattedItems = results;
          }
        }).catch(() => {
          this.tableLoading = false;
        });
    },
    getAssignments() {
      let self = this;
      let filters = {
        page: 0,
        sort: "id",
        order: "desc",
        per_page: this.per_page,
        evaluation_survey: 1
      };
      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/get-assignments",
          filters: filters,
        })
        .then((response) => {
          self.assignmentList = [
            {
              id: "all",
              name: this.$t("general.all"),
            },
          ];
          if (response.status) {
            let results = [];
            let items = response.data;
            items.forEach((item) => {
              self.assignmentList.push({
                id: item.id,
                name: item.full_name,
                order_number: item.order_number,
              });
            });
            //this.assignmentList = results;
          }
        });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.order = order;
      this.sort = sort;

      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    handleAssignmentInput(value) {
      this.error = null;
      this.getUsers(value);
    },
    resetFilter() {
      this.assignment_id = [];
      this.user_id = null;
      this.userList = [];
      this.lastFilter = null;

      this.formattedItems = [];
      this.pagination = null;
      this.error = this.$t("validation.please_select_assignment");
    },
  },
  mounted() {
    this.getAssignments();
    this.checkInitialState();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
  },
  beforeDestroy() {
    const modal = UIkit.modal("#modal-profile");
    if (modal) modal.$destroy(true);
  },
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
